import { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { ROUTES } from '@shared/constants/routes.constants';
import { AUTH_ROUTES } from '@feature/auth';

/**
 * Rutas de redirección y manejo de rutas no encontradas
 */
export const redirectRoutes: RouteObject[] = [
  {
    path: ROUTES.PUBLIC.ROOT,
    element: <Navigate to={AUTH_ROUTES.LOGIN} replace />,
  },
  {
    path: '*',
    element: <Navigate to={AUTH_ROUTES.LOGIN} replace />,
  },
];
